import { useContext } from 'react';
import { formatPlurality } from '@trinity/chat-components';
import { SearchLoadingQuantAnalysesContext, SearchResultsQuantAnalysesContext } from '@/containers/WorkspaceGlobalSearch/Context';
import styles from './style/Tab.module.css';
import Table from './Search.Table.QuantAnalyses';

const max = 50;

export default function SearchTabQuantAnalyses() {
  const quantanalyses = useContext(SearchResultsQuantAnalysesContext);
  const loading = useContext(SearchLoadingQuantAnalysesContext);

  const isLoading = loading.untouched && loading.loading;

  const data = quantanalyses?.items ?? [];
  const countText = !isLoading
    ? `(${getCountLabel(quantanalyses?.total ?? 0, 'Analyses')})`
    : null;
  const pagination = data.length > 25;

  return (
    <div className={styles.root}>
      <Table
        data={data}
        countText={countText}
        pagination={pagination}
        pageSize={25}
        isLoading={isLoading} />
    </div>
  );
}

function getCountLabel(total: number, label: string) {
  return total > max
    ? `+${max} ${formatPlurality(label, max)}`
    : `${total} ${formatPlurality(label, total)}`;
}

export { SearchTabQuantAnalyses };